import { render } from "./BooleanToggleButtons.vue?vue&type=template&id=1853f4ca"
import script from "./BooleanToggleButtons.vue?vue&type=script&lang=js"
export * from "./BooleanToggleButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__